import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Header } from "../components/header/index.tsx";
import { Seo } from "../components/seo/index.tsx";
import { Container } from "../components/styled.ts";
import { useMobile } from "../hooks/isMobile.tsx";
import { subscriberContext } from "../context/subscriberContext.tsx";
import NotificationFilters from "../pages/NotificationFilters.tsx";

const NotificationFiltersView = () => {
  const { isMobile } = useMobile();
  const history = useHistory();
  const { subscriberDetails, isError } = useContext(subscriberContext);

  useEffect(() => {
    if (isError) {
      history.push("/");
    }
  }, [isError, history]);

  return (
    <>
      <Seo title="Notification Filters | FinQ India" path="/notification-filters" noindex />
      <Header active="notification-filters" />
      <Container
        column
        width="100%"
        justifyContent="flex-start"
        alignItems="center"
        padding={isMobile ? "20px 15px" : "20px 40px"}
        minHeight="calc(100vh - 80px)"
      >
        {subscriberDetails?.phoneNumber && <NotificationFilters />}
      </Container>
    </>
  );
};

export default NotificationFiltersView;
